module.exports = __webpack_public_path__ + "media/images/dialog_box-aeb94e52.svg";